import { Component, Output, EventEmitter, OnInit, Input, Inject } from '@angular/core';
import { BaseComponent } from '../../base/base.component';
import { TranslateService } from '@ngx-translate/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


export interface ConfirmationDialogData {
  title: string;
  message: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent extends BaseComponent implements OnInit {
  @Output() confirm = new EventEmitter<void>();
  @Output() cancel = new EventEmitter<void>();

  userConfirmedAction: boolean = false;

  constructor(
    private readonly translate: TranslateService, public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.setButtonsText();
  }

  setButtonsText () {
    if (this.data.confirmButtonText === "") {
      this.data.confirmButtonText = this.translate.instant("confirmationDialog.confirmButtonText");
    }
    if (this.data.cancelButtonText === "") {
      this.data.cancelButtonText = this.translate.instant("confirmationDialog.cancelButtonText");
    }
  }

  onConfirm() {
    this.userConfirmedAction = true;
    this.confirm.emit();
    this.dialogRef.close(this.userConfirmedAction);
  }

  onCancel() {
    this.userConfirmedAction = false;
    this.cancel.emit();
    this.dialogRef.close(this.userConfirmedAction);
  }
}
